import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { ifProp, theme } from 'styled-tools';
import styled, { css } from 'styled-components/macro';

const StyledContainer = styled(Container)`
  margin-bottom: 3rem;
  margin-top: 3rem;
  min-height: 31.25rem;

  ${ifProp(
    { width: 'full' },
    css`
      background: ${theme('colors.white')};
      border-radius: ${theme('borderRadius')};
      padding: 1.25rem;
    `
  )}

  ${ifProp(
    { margin: 'top-small' },
    css`
      margin-top: 1rem;
    `
  )}

  ${ifProp(
    { padding: 'none' },
    css`
      padding: 0;
    `
  )}
`;

StyledContainer.propTypes = {
  margin: PropTypes.string,
  padding: PropTypes.string,
  width: PropTypes.string,
};

StyledContainer.defaultProps = {
  margin: '',
  padding: '',
  width: '',
};

export default StyledContainer;
